import { CHRONO, EBAT } from '@/common/constants';
import favicon from '@/ebat/assets/favicon/favicon.ico';
import touch from '@/ebat/assets/favicon/logo192.png';
import { ReactComponent as LogoChrono } from '@/ebat/assets/logos/chrono.svg';
import { ReactComponent as LogoChronoWhite } from '@/ebat/assets/logos/chrono-white.svg';
import { ReactComponent as SmallLogoEbat } from '@/ebat/assets/logos/ebat-small.svg';
import LogoEbat from '@/ebat/components/blocks/Assets/LogoEbat/LogoEbat';

const ThemeEbat = {
  Logo: LogoEbat,
  PartnerLogo: LogoChrono,
  PartnerLogoWhite: LogoChronoWhite,
  SmallLogo: SmallLogoEbat,
  defaultI18n: EBAT,
  favicon,
  manifest: `${process.env.PUBLIC_URL}/manifest.ebat.json`,
  partnerEnv: CHRONO,
  partnerHost: `//${process.env.REACT_APP_HOST_CHRONO}`,
  touch,
};

export default ThemeEbat;
